var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-popover',{staticClass:"cursor-pointer outline-none",attrs:{"trigger":"hover"}},[_c('Info'),_vm._t("default",null,{"slot":"popover"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }